import { Label } from '@/components/shadcn/ui/label';
import { Toggle } from '@/components/shadcn/ui/toggle';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormToggleProps extends Omit<
  React.ComponentProps<typeof Toggle>,
  'pressed' | 'onPressedChange'
> {
  label?: string;
  showErrorMessage?: boolean;
}

export function FormToggle({
  label,
  showErrorMessage = true,
  children,
  ...props
}: FormToggleProps) {
  const field = useFieldContext<boolean>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Toggle
          id={field.name}
          pressed={field.state.value ?? false}
          onPressedChange={(pressed) => field.handleChange(pressed)}
          {...props}
        >
          {children}
        </Toggle>
        {label && (
          <Label htmlFor={field.name} className="cursor-pointer">
            {label}
          </Label>
        )}
      </div>
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
